import { cn } from '@dialogueconsulting/sked-ui/lib/utils'

import { ClockIcon } from 'Icons'

/**
 * Scheduled-time label (clock icon + time). Tailwind replacement for the
 * old `TimeStyled` styled-component shared by the desktop card and the
 * mobile StatusLabel. On mobile it sits on a coloured status bar, so it
 * renders white.
 */
function PostTime({ time, isMobile }: { time: string; isMobile?: boolean }) {
  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 text-xs font-bold [&_svg]:size-[15px]',
        isMobile
          ? 'm-0 text-white [&_svg]:stroke-white'
          : 'mb-3.5 mt-px text-blue-500'
      )}
    >
      <ClockIcon />
      {time}
    </div>
  )
}

export default PostTime
